export const escapeRegExp = str => String(str).replace(/[-[\]{}()*+!<=:?./\\^$|#\s,]/g, '\\$&')
